import { combineReducers } from 'redux'
import { SettingsState, settingsStateReducer } from './settings/settings.reducer'
import { DataState, dataStateReducer } from '../store/data/data.reducer'

export interface SettingsRootState {
  settingsStore: SettingsState
  dataStore: DataState
}

export const rootReducer = combineReducers<SettingsRootState>({
  settingsStore: settingsStateReducer,
  dataStore: dataStateReducer,
})
